import * as React from 'react';
import cs from 'classnames';
import s from './OnlyIn.module.less';

type Props = { children: React.ReactNode; className?: string | null };

const OnlyInDesktopTablet = ({ children, className = null }: Props) => (
  <div className={cs([s.desktopAndTablet, className])}>{children}</div>
);

export default OnlyInDesktopTablet;
